import React from 'react'

const Policy = () => {
    return (
        <div className='py-5'>
            <h2 className='h2 text-center'>개인정보처리방침</h2>

            <div className='py-4 policy'>
                (주)HY교육 “HY프로그램” 개인정보 처리방침<br/>
                (주)HY교육(이하 '회사')은 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.<br/>
                <br/>
                제1조(개인정보의 처리 목적)<br/>
                회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br/>
                1. 회원 가입 및 관리 : 회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정 이용 방지, 각종 고지·통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.<br/>
                2. 재화 또는 서비스 제공 : 서비스 제공, 청구서 발송, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 요금결제·정산 등을 목적으로 개인정보를 처리합니다.<br/>
                3. 마케팅 및 광고에의 활용 : 신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재 등을 목적으로 개인정보를 처리합니다.<br/>
                <br/>
                제2조(처리하는 개인정보의 항목)<br/>
                회사는 다음의 개인정보 항목을 처리하고 있습니다.<br/>
                1. 회원 가입 및 관리<br/>
                - 필수항목: 성명, 생년월일, 아이디, 비밀번호, 이메일, 전화번호<br/>
                - 선택항목: 성별, 주소<br/>
                2. 재화 또는 서비스 제공<br/>
                - 필수항목: 성명, 생년월일, 아이디, 비밀번호, 이메일, 전화번호, 결제정보<br/>
                - 선택항목: 성별, 주소<br/>
                3. 마케팅 및 광고에의 활용<br/>
                - 필수항목: 성명, 생년월일, 이메일, 전화번호<br/>
                - 선택항목: 성별, 주소, 관심사<br/>
                <br/>
                제3조(개인정보의 처리 및 보유 기간)<br/>
                회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.<br/>
                1. 회원 가입 및 관리 : 회원 탈퇴 시까지. 다만, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지.<br/>
                2. 재화 또는 서비스 제공 : 재화·서비스 공급 완료 및 요금 결제·정산 완료 시까지. 다만, 관계 법령에 따라 보존해야 하는 경우에는 그 기간에 따름.<br/>
                - 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자 보호에 관한 법률)<br/>
                - 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자 보호에 관한 법률)<br/>
                - 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자 보호에 관한 법률)<br/>
                <br/>
                제4조(개인정보의 제3자 제공)<br/>
                회사는 정보주체의 개인정보를 개인정보 보호법 제17조 및 제18조에 따라 제3자에게 제공하고 있으며, 개인정보를 제공받는 자, 제공 목적, 제공하는 개인정보 항목, 제공받는 자의 개인정보 보유 및 이용 기간은 다음과 같습니다.<br/>
                제공받는 자 : [(주) HY교육 소속 컨설턴트]<br/>
                제공 목적 : [학생 정보를 활용한 개인맞춤형 대입정보제공 목적]<br/>
                제공 항목 : [항목]<br/>
                보유 및 이용 기간 : [기간]<br/>
                <br/>
                제5조(개인정보 처리의 위탁)<br/>
                회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.<br/>
                수탁업체 : [수탁업체 명칭]<br/>
                위탁 업무 내용 : [업무 내용]<br/>
                위탁 기간 : [기간]<br/>
                <br/>
                제6조(정보주체와 법정대리인의 권리·의무 및 그 행사방법)<br/>
                정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br/>
                1. 개인정보 열람 요구<br/>
                2. 오류 등이 있을 경우 정정 요구<br/>
                3. 삭제 요구<br/>
                4. 처리정지 요구<br/>
                <br/>
                제7조(개인정보의 파기)<br/>
                회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다. 파기 절차 및 방법은 다음과 같습니다.<br/>
                1. 파기절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.<br/>
                2. 파기방법 : 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제하고, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통해 파기합니다.<br/>
                <br/>
                제8조(개인정보의 안전성 확보 조치)<br/>
                회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.<br/>
                1. 관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 등<br/>
                2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화<br/>
                3. 물리적 조치 : 전산실, 자료보관실 등의 접근 통제<br/>
                <br/>
                제9조(개인정보 보호책임자)<br/>
                회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br/>
                개인정보 보호책임자 : [전대근, 대표, 02-]<br/>
                개인정보 보호 담당부서 : [사업기획부, 02-]<br/>
                <br/>
                ## 제10조(개인정보 처리방침 변경)<br/>
                이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.<br/>
                이 개인정보 처리방침은 (주)HY교육의 HY프로그램 웹사이트 이용자들에게 개인정보 처리와 관련된 중요한 내용을 알리고, 이를 투명하게 공개함으로써 이용자의 개인정보 보호에 만전을 기하고자 합니다.<br/>
                HY 프로그램 청소년 보호정책<br/>
                HY 프로그램 ("웹사이트" 또는 "프로그램"이라 함)는 청소년이 건전한 인격체로 성장할 수 있도록 하기 위하여 청소년 보호정책을 수립, 시행하고 있습니다.<br/>
                회사는 청소년들이 유해정보에 접근할 수 없도록 방지하고 있는 바, 본 청소년 보호정책을 통하여 회사가 청소년보호를 위해 어떠한 조치를 취하고 있는지 알려드립니다.<br/>
                <br/>
                1. 유해정보에 대한 청소년접근제한 및 관리조치<br/>
                프로그램은 청소년이 아무런 제한장치 없이 청소년 유해정보에 노출되지 않도록 별도의 인증장치를 마련, 적용하며 청소년 유해정보가 노출되지 않기 위한 예방차원의 조치를 강구합니다.<br/>
                <br/>
                2. 유해정보로부터의 청소년보호를 위한 업무 담당자 교육 시행<br/>
                회사는 정보통신업무 종사자를 대상으로 청소년보호 관련 법령 및 제재기준, 유해정보 발견시 대처방법, 위반사항 처리에 대한 보고절차 등을 교육하고 있습니다.<br/>
                <br/>
                3. 유해정보로 인한 피해상담 및 고충처리<br/>
                회사는 청소년 유해정보로 인한 피해상담 및 고충처리를 위한 전문인력을 배치하여 그 피해가 확산되지 않도록 하고 있습니다.<br/>
                이용자 분들께서는 하단에 명시한 "4. HY 프로그램 청소년보호 책임자 및 담당자의 소속, 성명 및 연락처" 항을 참고하여 전화나 메일을 통하여 피해상담 및 고충처리를 요청할 수 있습니다.<br/>
                <br/>
                4. HY 프로그램 청소년보호 책임자 및 담당자의 소속, 성명 및 연락처<br/>
                (주) HY교육은 청소년들이 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고 있습니다.<br/>
                <br/>
                청소년 보호 책임자<br/>
                이 름 : 전대근<br/>
                소 속 : 대표실<br/>
                직 위 : 대표<br/>
                <br/>

                청소년 보호 담당자<br/>
                이 름 : 강진헌<br/>
                소 속 : 사업기획부<br/>
                직 위 : 부팀장<br/>
                <br/>

                메 일 : main@youngjalguk.com<br/>
                전 화 : 02-561-9455<br/>
                <br/>

            </div>
        </div>
    )
}

export default Policy